export default __webpack_public_path__ + "images/e216.jpg";